import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiDialogActions, { DialogActionsProps as MuiDialogActionsProps } from '@material-ui/core/DialogActions';

const styles = ({ spacing: { unit }, breakpoints: { down } }: Theme) =>
  createStyles({
    root: {},
    action: {},
  });

export interface DialogActionsProps extends Omit<MuiDialogActionsProps, 'classes'>, WithStyles<typeof styles> {}

const DialogActions: React.FC<DialogActionsProps> = ({ classes, ...rest }) => (
  <MuiDialogActions
    classes={{
      root: classes.root,
      action: classes.action,
    }}
    {...rest}
  />
);

export default withStyles(styles, { name: 'LumaDialogActions' })(DialogActions);
